import { GeoArea } from "./services/listingsSearchCriteriaApi";

export function geoAreaContains(geoArea: GeoArea, point: [number, number]): boolean {
    if (geoArea.type === "Polygon") {
        return ringContains(geoArea.coordinates[0], point);
    }
    return geoArea.coordinates.some(polygon => ringContains(polygon[0], point));
}

export function ringContains(ring: [number, number][], [px, py]: [number, number]): boolean {
    let inside = false;
    for (let i = 0, j = ring.length - 1; i < ring.length; j = i++) {
        const [xi, yi] = ring[i];
        const [xj, yj] = ring[j];
        if ((yi > py) !== (yj > py) && px < ((xj - xi) * (py - yi)) / (yj - yi) + xi) {
            inside = !inside;
        }
    }
    return inside;
}

// Hues assigned so that geographically adjacent London postcode areas get clearly
// different colours. Covers all London-area codes; others fall back to hash.
const POSTCODE_AREA_HUES: Record<string, number> = {
    // Inner London
    E: 145, EC: 0, N: 235, NW: 30, SE: 295, SW: 175, W: 355, WC: 265,
    // Outer London
    BR: 60, CR: 205, DA: 100, EN: 265, HA: 100, IG: 60,
    KT: 235, RM: 30, SM: 30, TW: 205, UB: 295,
    // Home Counties visible on London-area map
    AL: 175, CM: 175, GU: 60, HP: 265, LU: 30,
    ME: 145, RH: 265, SG: 325, SL: 0, SS: 265, TN: 325, WD: 60,
};

function hueForId(id: string): number {
    const h = POSTCODE_AREA_HUES[id.toUpperCase()];
    if (h !== undefined) return h;
    let hash = 0;
    for (let i = 0; i < id.length; i++) hash = id.charCodeAt(i) + ((hash << 5) - hash);
    return (Math.abs(hash) * 137) % 360;
}

export function colorFromId(id: string): string {
    return `hsl(${hueForId(id)}, 45%, 58%)`;
}

export function brightColorFromId(id: string): string {
    return `hsl(${hueForId(id)}, 72%, 44%)`;
}

export function polygonCentroid(coordinates: [number, number][][]): [number, number] {
  const ring = coordinates[0];
  const pts =
    ring[0][0] === ring[ring.length - 1][0] && ring[0][1] === ring[ring.length - 1][1]
      ? ring.slice(0, -1)
      : ring;
  const sumLng = pts.reduce((s, p) => s + p[0], 0);
  const sumLat = pts.reduce((s, p) => s + p[1], 0);
  return [sumLng / pts.length, sumLat / pts.length];
}
